/**
 *  售后中心-掌柜预警-退款预警
 */

import {get, post, postJson, deleteApi, postUrl} from '../axios'

// const RESOURCE_BASE_PATH = 'http://192.168.1.235:8000/jd-yusms/refundWaring/'
const RESOURCE_BASE_PATH = '/refundWaring/'

// 删除退款预警
export const deleteId = id => deleteApi(`${RESOURCE_BASE_PATH}delete/${id}`);

// 查询短信记录
export const querySmsList = p => get(`${RESOURCE_BASE_PATH}getRefundSendRecord`, p);

// 退款预警任务列表
export const queryTaskList = p => get(`${RESOURCE_BASE_PATH}getRefundWaringPage`, p);

// 更新开启状态/优先级
export const openState = p => postUrl(`${RESOURCE_BASE_PATH}openState`, p);

// 保存\更新退款预警
export const updateAndSave = p => postJson(`${RESOURCE_BASE_PATH}updateAndSave`, p);

// 查询退款预警详情
export const getDetails = id => get(`${RESOURCE_BASE_PATH}${id}`);